export enum Splashscreen {
  default = 1,
  second = 2,
  third = 3,
  fourth = 4,
  custom = 5
}
